module.exports = __webpack_public_path__ + "img/doc-empty-img2.b0c38779.png";